<template lang="pug">
	.content-static-pages
		.inside
			ol(type='A')
				li.head
					router-link(to='/faq-a')
						span: | What services does EasyTitle24.com offer ?
					ol(type='1')
						li.kid
							a(href='/faq-a#a-1')
								span: | What can I do at EasyTitle24.com that I can't do elsewhere?
						li.kid
							a(href='/faq-a#a-1')
								span: | Is there a charge for using EasyTitle24.com?
						li.kid
							a(href='/faq-a#a-3')
								span: | What's included in the "Standard Residential Report"?
						li.kid
							a(href='/faq-a#a-4')
								span: | What's included in the "Preliminary Run Results"?
						li.kid
							a(href='/faq-a#a-5')
								span: | What's included in the "Heating & Cooling Load Calculations"?
						li.kid
							a(href='/faq-a#a-6')
								span: | Do these reports come with a Warrantee?
				li.head
					a(href='/faq-b')
						span: | How do I use this site, and how do I file the report?
					ol(type='1')
						li.kid
							a(href='/faq-b#b-1')
								span: | Who should sign the Report?
						li.kid
							a(href='/faq-b#b-2')
								span: | What general capabilities will I need in order to use the do-it-yourself tools?
						li.kid
							a(href='/faq-b#b-3')
								span: | Why do I have to log in?
						li.kid
							a(href='/faq-b#b-4')
								span: | What is your privacy policy?
						li.kid
							a(href='/faq-b#b-5')
								span: | How is the report sent to me?
						li.kid
							a(href='/faq-b#b-6')
								span: | What do I do with the report?
						li.kid
							a(href='/faq-b#b-7')
								span: | What if my building department requires the Certificate of Compliance and Mandatory Measures to be printed on the building plans?
				li.head
						router-link(to='/faq-c')
							span: | What do I need to know about California Title 24 Regulations ?
						ol(type='1')
							li.kid
								a(href='/faq-c#c-1')
									span: | What is Title 24?
							li.kid
								a(href='/faq-c#c-2')
									span: | How is Title 24 enforced?
							li.kid
								a(href='/faq-c#c-3')
									span: | Who can perform Title 24 compliance analysis?
							li.kid
								a(href='/faq-c#c-4')
									span: | Can't I do the documentation myself?
							li.kid
								a(href='/faq-c#c-5')
									span: | What information do I need to give to an Energy Consultant?
							li.kid
								a(href='/faq-c#c-6')
									span: | Will the Title 24 code change soon?
							li.kid
								a(href='/faq-c#c-7')
									span: | What is "glazing percentage?"
							li.kid
								a(href='/faq-c#c-8')
									span: | What is conditioned space ?
							li.kid
								a(href='/faq-c#c-9')
									span: | What is non-conditioned space ?
							li.kid
								a(href='/faq-c#c-10')
									span: | What are HERS measures?
				li.head
						router-link(to='/faq-d')
							span: | What if I encounter a problem ?
						ol(type='1')
							li.kid
								a(href='/faq-d#d-1')
									span: | What if a planchecker rejects my report?
							li.kid
								a(href='/faq-d#d-2')
									span: | What if I'm required to get a third party HERS verification?
							li.kid
								a(href='/faq-d#d-3')
									span: | What if a building inspector finds construction not in conformance?
							li.kid
								a(href='/faq-d#d-4')
									span: | What if I cannot find component(s) that meet the criteria specified in the report?
							li.kid
								a(href='/faq-d#d-5')
									span: | What if I want to change my design after Title 24 compliance has been completed?
							li.kid
								a(href='/faq-d#d-6')
									span: | Are there any jurisdictions that are particularly difficult?
							li.kid
								a(href='/faq-d#d-7')
									span: | What if my project is in a tough jurisdiction?
				li.head
						router-link(to='/faq-e')
							span: | About your Project
						ol(type='1')
							li.kid
								a(href='/faq-e#e-1')
									span: | Location
							li.kid
								a(href='/faq-e#e-2')
									span: | Building Type
							li.kid
								a(href='/faq-e#e-3')
									span: | Orientation of Front Faces
							li.kid
								a(href='/faq-e#e-4')
									span: | Conditioned Floor Area
				li.head
						router-link(to='/faq-f')
							span: | About Mechanical Systems
						ol(type='1')
							li.kid
								a(href='faq-f#f-1')
									span: | Supply Register Location
							li.kid
								a(href='faq-f#f-2')
									span: | Tested Leakage Credit
							li.kid
								a(href='faq-f#f-3')
									span: | Thermal Expansion Valve (TVX)
							li.kid
								a(href='faq-f#f-4')
									span: | ACCA Manual D Design Credit
							li.kid
								a(href='faq-f#f-5')
									span: | Cooling System Type
				li.head
						router-link(to='/faq-g')
							span: | About Walls and Vertical Surfaces
						ol(type='1')
							li.kid
								a(href='/faq-g#g-1')
									span: | Average Plate Height
							li.kid
								a(href='/faq-g#g-2')
									span: | Perimeter Length
							li.kid
								a(href='/faq-g#g-3')
									span: | House Wrap Credit
							li.kid
								a(href='/faq-g#g-4')
									span: | Exterior Doors - Opaque Surfaces
							li.kid
								a(href='/faq-g#g-5')
									span: | Other Walls
							li.kid
								a(href='/faq-g#g-6')
									span: | Wall Insulation
							li.kid
								a(href='/faq-g#g-7')
									span: | Orientation
				li.head
						router-link(to='/faq-h')
							span: | About Floors and Roofs
						ol(type='1')
							li.kid
								a(href='/faq-h#h-1')
									span: | roof covered by addition
							li.kid
								a(href='/faq-h#h-2')
									span: | Enclosed Crawlspace
							li.kid
								a(href='/faq-h#h-3')
									span: | Radiant Barrier Credit
							li.kid
								a(href='/faq-h#h-4')
									span: | Cool Roof Credit
							li.kid
								a(href='/faq-h#h-5')
									span: | Special Rooves
							li.kid
								a(href='/faq-h#h-6')
									span: | Projected Area
							li.kid
								a(href='/faq-h#h-7')
									span: | Roof - Ceiling Insulation
							li.kid
								a(href='/faq-h#h-8')
									span: | Floor Insulation
							li.kid
								a(href='/faq-h#h-9')
									span: | Orientation
				li.head
						router-link(to='/faq-i')
							span: | About Windows and Glazing
						ol(type='1')
							li.kid
								a(href='/faq-i#i-1')
									span: | Custom Overhang - Warm zone
							li.kid
								a(href='/faq-i#i-2')
									span: | Typical Window Header Height - Warm Zone
							li.kid
								a(href='/faq-i#i-3')
									span: | Typical Overhang Length - Warm Zone
							li.kid
								a(href='/faq-i#i-4')
									span: | Typical Plate Height - Warm Zone
							li.kid
								a(href='/faq-i#i-5')
									span: | Re-Using and Replacing Existing Glazing
							li.kid
								a(href='/faq-i#i-6')
									span: | Orientation

</template>

<script>
import AnchorRouterLink from 'vue-anchor-router-link'
export default {
	name: 'faq-content',
	components: {
		AnchorRouterLink
	}
}
</script>



// WEBPACK FOOTER //
// src/components/resources/content-faq.vue